import rill from "rill";

import redirect from "@rill/redirect";
import ensureUser from "../../middleware/ensure-user";
import ensureFirstTimeAthlete from "../../middleware/ensure-first-time-athlete";
import ensureCoachRedirection from "../../middleware/ensure-coach-redirection";
import ensureAthleteUpgrade from "../../middleware/ensure-athlete-upgrade";
import ensureSetup from "../../middleware/ensure-setup";
import ensurePaid from "../../middleware/ensure-paid";

import HomeDay from "./home-day";
import HomeWeek from "./home-week";
import Support from "./support";
import Settings from "./settings";
import Metrics from "./metrics";
import ProgramBuilder from "./program-builder";
import ProgramLibrary from "./program-library";
import Competitions from "./competitions";
import Notifications from "./notifications";
import Profile from "./profile/index";
import Calendar from "./calendar";

const Dashboard = (app) => {
  app.get("/dashboard", redirect("/dashboard/calendar")).at(
    "/dashboard/*",
    ensureUser,
    ensurePaid,
    ensureFirstTimeAthlete,
    ensureCoachRedirection,
    ensureAthleteUpgrade,
    rill()
      .get(ensureSetup)
      .use(({ load }, next) => load("listNotifications", {
        limit: false,
      }).then(next))
      .setup(HomeDay)
      .setup(HomeWeek)
      .setup(Support)
      .setup(Settings)
      .setup(Metrics)
      .setup(ProgramBuilder)
      .setup(ProgramLibrary)
      .setup(Competitions)
      .setup(Notifications)
      .setup(Profile)
      .setup(Calendar)
  );
};

export default Dashboard;
